const doc = [({"installment":"Splátky", "limited_subscription":"Limitované předplatné", "one_time":"Jednorázově", "subscription":"Předplatné"})];
module.exports = doc.length <= 1 ? doc[0] : doc;